import * as React from 'react';
import * as XLSX from 'xlsx';

import { cloneElement } from 'react';
import { useListContext, AutocompleteArrayInput, Create, Edit, ReferenceArrayInput, SaveButton, SelectArrayInput, Show, Toolbar, useDataProvider, useDatagridStyles } from 'react-admin'
import { MarkdownField, MarkdownInput } from "@react-admin/ra-markdown";
import { Link } from 'react-router-dom';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { makeStyles } from "@material-ui/core/styles";
import classnames from 'classnames';
import { useGetOne } from 'react-admin';

import {
  Datagrid,
  DateField,
  useRecordContext,
  FileInput,
  FileField,
  ImageField,
  List,

  ReferenceField,
  SelectInput,
  SimpleShowLayout,
  ArrayInput,
  SimpleFormIterator,
  TextField,
  FormDataConsumer,
  ReferenceInput,
  RecordContextProvider,
  TextInput, required,
  TopToolbar,
  CreateButton,
  usePermissions,
  Filter,
  AutocompleteInput,
  NumberField,
  ChipField,
  BooleanInput,
  SimpleForm
} from "react-admin";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Divider,
  Box,
  Button,
  Typography,
  Table,
} from '@material-ui/core';
import { Add } from "@material-ui/icons";
import GetAppIcon from '@material-ui/icons/GetApp';

import { isMobile, useMobileOrientation } from 'react-device-detect';
// import { RealTimeList } from '@react-admin/ra-realtime';


import { IdateTimeInput } from '../../data/IdateTimeInput';
import { ROLES, SERVER_DOMAIN } from '../../constants';
import useDetectKeyboardOpen from "use-detect-keyboard-open";
import { CreateCustomerOrContactDialog } from '../crm/customer/Customer';
import { CreateContactDialog } from '../crm/contact/Contact';
import { CreateFormActions } from '../../components/FormActions';

export const styleProductNumber = { position: 'relative', width: "90px", marginLeft: "8px" }
export const styleProduct = { position: 'relative', width: "300px", marginLeft: "8px" }

const SearchNeed = (props) => {
  const { permissions } = usePermissions();

  return (
    <Filter {...props}>
      <ReferenceArrayInput variant="outlined" label="نوع درخواست " alwaysOn source="needCategoryId" reference="needCategory"  >
        <SelectArrayInput optionText="title" />
      </ReferenceArrayInput>
      {/* <ReferenceInput variant="outlined" label="وضعیت " source="statusId" reference="status" >
        <SelectInput optionText="title" allowEmpty />
      </ReferenceInput> */}
      {(!permissions?.includes(ROLES.USER_EXPERIMENTAL)) && <BooleanInput optionText="isArchived" alwaysOn label="پایان کار بیشتر از دو روز" source="isArchived" />}
      <ReferenceInput variant="outlined" label="واحد گیرنده " alwaysOn source="unitId" reference="unit" >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <ReferenceInput filter={{ unitId: props?.filterValues?.unitId }} disabled={(props?.filterValues?.unitId === undefined ? true : false)} alwaysOn variant="outlined" label=" پردازنده " source="unitProcessorId" reference="unitProcessor" >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <ReferenceInput perPage={1000} variant="outlined" label="درخواست کننده " source="owner" reference="adminUsers" >
        <SelectInput optionText="name" />
      </ReferenceInput>

      {/* <ReferenceInput variant="outlined" label="پردازنده " source="unitProcessorId" reference="unitProcessor" >
        <SelectInput optionText="title" />
      </ReferenceInput> */}


      {/* <AutocompleteInput optionText="refNum" alwaysOn/> */}
      <TextInput label=" جستجو" source="q" variant="outlined" alwaysOn />
    </Filter>
  )
};

const NeedListActions = (props) => (
  <TopToolbar>
    {cloneElement(props.filters, { context: 'button' })}
    <CreateButton />
  </TopToolbar>
);

export const postRowClick = (id, resource, record) => record.isArchived ? 'show' : 'edit';


const ExportButton = () => {
  const { filterValues } = useListContext();

  const handleExport = async () => {
    try {
      // Construct the query string
      // Get the current filters

      const filter = JSON.stringify(filterValues || {});
      const encodedFilter = encodeURIComponent(filter); // Encode the JSON string
      const queryParams = `filter=${encodedFilter}`;
      const token = localStorage.getItem('Authorization');

      const response = await fetch(SERVER_DOMAIN + `/admin/needexport?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
      });

      if (!response.ok) {
        throw new Error('Failed to export data');
      }
      const data = await response.json(); // Assuming response is JSON
      if (!Array.isArray(data)) {
        throw new Error('Response is not an array');
      }
      const transformProducts = (products) => {
        return products.map(product => {
          const productTitle = product.objectId ? product.objectId.title : 'Unknown Product'; // Get the product title
          const packageP = product.objectId?.productPackages?.find(pkg => pkg._id === product.productPackageId); // Find the matching packageP
          const packageTitle = packageP ? packageP.title : 'Unknown Package'; // Get the packageP title if it exists
          const count = product.number || 0; // Get the count (stored in the 'number' field)

          // Format: Product Title - Package Title (Count)
          return `${productTitle} - ${packageTitle} (${count})`;
        }).join(', '); // Join multiple products with a comma if there are more than one
      };

      const transformFields = (item) => {
        Object.entries(item).forEach(([key, value]) => {
          // If the value is an object with a 'title' property, replace it with the title
          if (value && value.title) {
            item[key] = value.title; // Replace object with title
          } else if (Array.isArray(value)) {
            // If it's an array, check each item in the array
            if (key === 'products') {
              item[key] = transformProducts(value); // Transform products array into a readable string
            } else {
              item[key] = value.map(subItem => {
                if (subItem.nId && subItem.nId.title) {
                  subItem.nId = subItem.nId.title; // Replace sub-need nId object with title
                }
                return subItem;
              });
            }
          }
        });
        return item;
      };



      const columnMapping = {
        title: 'عنوان',
        description: 'توضیحات',
        descript: 'توضیحات کوتاه',
        needCategoryId: 'دسته درخواست',
        ownerName: 'ایجاد کننده',
        products: 'محصولات',
        dueDate: 'تاریخ تحویل',
        createdAt: 'تاریخ ایجاد',
        updatedAt: 'آخرین بروزرسانی',
        unitId: 'واحد',
        unitProcessorId: 'پردازشگر واحد',
        statusId: 'وضعیت',
        customerNumber: 'شماره مشتری',
        customerName: 'نام مشتری',
        customerId: 'شناسه مشتری',
        contactId: 'شناسه مخاطب',
        needParentId: 'شناسه والد درخواست',
        // subNeeds: 'زیر درخواست‌ها',
        deliveryLocation: 'مکان تحویل',
        refNum: 'شماره مرجع',
        isArchived: 'آرشیو شده',
        // lastReminders: 'آخرین یادآوری‌ها',
        // usersInvolved: 'کاربران درگیر',
      };
      const fieldsToInclude = Object.keys(columnMapping);


      // Map the data
      const mappedData = data.map(item => {
        const mappedItem = {};

        // Transform the fields before mapping
        transformFields(item);

        // Map the data according to the columnMapping and fieldsToInclude
        for (const key of fieldsToInclude) {
          if (item[key] !== undefined) {
            mappedItem[columnMapping[key]] = item[key]; // Use mapped column name
          }
        }

        return mappedItem;
      });

      const worksheet = XLSX.utils.json_to_sheet(mappedData); // Converts JSON to a worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Write the workbook to an array buffer
      const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

      // Create a download link for the Blob
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'export-needs.xlsx';
      link.click();

      // Cleanup
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Export error:', error);
      alert(error);
    }
  };
  return (
    <button
      onClick={handleExport}
      className="inline-flex items-center px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-75 transition-transform transform hover:scale-105 max-w-max"
    >
      <GetAppIcon className="mr-2" />
      دریافت  خروجی با جزییات
    </button>);
};
const ExportButtonNew = () => {
  const { filterValues } = useListContext();

  const handleExport = async () => {
    try {
      // Construct the query string
      const filter = JSON.stringify(filterValues || {});
      const encodedFilter = encodeURIComponent(filter);
      const queryParams = `filter=${encodedFilter}`;
      const token = localStorage.getItem('Authorization');

      const response = await fetch(`${SERVER_DOMAIN}/admin/needexport?${queryParams}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to export data');
      }

      const data = await response.json();
      if (!Array.isArray(data)) {
        throw new Error('Response is not an array');
      }

      // Map products into separate rows
      const expandedData = [];
      data.forEach((need) => {
        const baseFields = {
          'تاریخ ایجاد': need.createdAt || '',
          'ایجاد کننده': need.ownerName || '',
          'واحد درخواست کننده': need.unitId?.title || '',
          عنوان: need.title || 'بدون عنوان',
          واحد: need.unitId?.title || '',
          'پردازشگر واحد': need.unitProcessorId?.title || '',
          'توضیحات کوتاه': need.descript || '',
          وضعیت: need.statusId?.title || '',
          'دسته درخواست': need.needCategoryId?.title || 'بدون دسته',
          'تاریخ تحویل': need.dueDate || '',
          'آخرین بروزرسانی': need.updatedAt || '',
          // 'شماره مشتری': need.customerNumber || '',
          'نام مشتری - مخاطب': need.customerId?.name || '',
          'محل تحویل': need.deliveryLocation || '',
          توضیحات: need.description || '',
          // 'شناسه مشتری': need.customerId || '',
          // 'مکان تحویل': need.deliveryLocation || '',
          // 'شماره مرجع': need.refNum || '',
          // 'آرشیو شده': need.isArchived ? 'بله' : 'خیر',
        };

        if (Array.isArray(need.products) && need.products.length > 0) {
          need.products.forEach((product) => {
            const productDetails = {
              محصول: product?.objectId?.title || '',
              بسته: product?.objectId?.productPackages?.find(
                (pkg) => pkg._id === product.productPackageId
              )?.title || '',
              "تعداد درخواست": product?.number || 0,
              "ارسالی": product?.sent || 0,
              "مانده": (product?.number || 0) - (product?.sent || 0),
            };
            expandedData.push({ ...baseFields, ...productDetails });
          });
        } else {
          // Handle needs with no products
          expandedData.push({
            ...baseFields,
            محصول: 'بدون محصول',
            بسته: 'بدون بسته',
            "تعداد درخواست": '',
            "ارسالی": '',
            "مانده": '',
          });
        }
      });

      // Convert data to Excel sheet
      const worksheet = XLSX.utils.json_to_sheet(expandedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Write the workbook to an array buffer
      const excelBuffer = XLSX.write(workbook, { type: 'array', bookType: 'xlsx' });
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });

      // Create a download link for the Blob
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'export-needs.xlsx';
      link.click();

      // Cleanup
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error('Export error:', error);
      alert('An error occurred during the export. Please try again.');
    }
  };

  return (
    <button
      onClick={handleExport}
      className="inline-flex items-center px-4 py-2 bg-cyan-500 hover:bg-cyan-600 text-white font-semibold rounded-lg shadow-md focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-opacity-75 transition-transform transform hover:scale-105 max-w-max"
    >
      <GetAppIcon className="mr-2" />
      دریافت خروجی با جزییات جدید
    </button>
  );
};



export const NeedList = (props) => {
  const { permissions } = usePermissions();
  const tableRef = React.useRef(null);

  return (
    <>
      <List  {...props} perPage={50} sort={{ field: 'updatedAt', order: 'DESC' }} actions={<NeedListActions />} filters={<SearchNeed />}  >
        <div >
          {(permissions?.includes(ROLES.SUPER_ADMIN) ||
            permissions?.includes(ROLES.USERS_ADMIN) ||
            permissions?.includes(ROLES.ANBAAR_ADMIN) ||
            permissions?.includes(ROLES.SALE_ADMIN)) && <div style={{float:"left"}}><ExportButton  /></div>
          }
          {(permissions?.includes(ROLES.SUPER_ADMIN) ||
            permissions?.includes(ROLES.USERS_ADMIN) ||
            permissions?.includes(ROLES.ANBAAR_ADMIN) ||
            permissions?.includes(ROLES.SALE_ADMIN)) && <div style={{float:"left"}}><ExportButtonNew /></div>
          }
          {isMobile ? (
            <Datagrid id="table-to-xls" ref={tableRef} rowClick={postRowClick} >
              <TextField source="title" />

              {/* <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
            <TextField source="title" />
          </ReferenceField> */}
              <ReferenceField link={null} label="وضعیت  " source="statusId" reference="status" >
                {/* <TextField source="title" style={postRowStyle}/> */}
                <ColoredChipField source="title" select="id" />
              </ReferenceField>
              <NumberField source="refNum" locales="en" textAlign="left" />

            </Datagrid>

          ) : (
            <Datagrid
              sx={{
                '.column-title': {
                  display: 'none'
                },
              }}
              id="table-to-xls" ref={tableRef} rowClick={postRowClick} >
              <TextField source="title" />
              <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
                <TextField source="title" />
              </ReferenceField>
              <ReferenceField link={null} label="واحد گیرنده " source="unitId" reference="unit" >
                <TextField source="title" />
              </ReferenceField>
              <ReferenceField link={null} label="زیر واحد " source="unitProcessorId" reference="unitProcessor" >
                <TextField source="title" />
              </ReferenceField>
              <TextField source="ownerName" label="درخواست کننده" />

              <DateField source="updatedAt" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
              {/* <TextField source="title" /> */}
              {permissions?.includes(ROLES.ROOT) && <ReferenceField link="show" label=" مشتری" source="customerId" reference="customer" allowEmpty>
                {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
                <TextField source="name" />
              </ReferenceField>
              }
              {permissions?.includes(ROLES.ROOT) && <ReferenceField link="show" label=" مخاطب" source="contactId" reference="contact" allowEmpty>
                {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
                <TextField source="name" />
              </ReferenceField>
              }

              {/* <TextField source="descript" /> */}
              {/* <MarkdownField  source="descript" label="" options={options} /> */}

              <NumberField source="refNum" locales="en" textAlign="left" />

              {/* <TextField source="description" /> */}
              {/* <TextField source="objectId" /> */}
              <DateField source="dueDate" label="تاریخ تحویل" options={{ year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute: '2-digit', second: '2-digit' }} locales="fa-IR" />
              <ReferenceField link={null} label="وضعیت  " source="statusId" reference="status" >
                {/* <TextField source="title" style={postRowStyle}/> */}
                <ColoredChipField source="title" select="id" />
              </ReferenceField>


              {/* <DateField locales={"fa-IR"} source="updatedAt" /> */}

            </Datagrid>
          )}
        </div>

      </List>
    </>
  )
};
export const ColoredChipField = props => {

  return (
    <ChipField
      source={props.record[props.source]}
      style={{ backgroundColor: props.record.stColor }}
      {...props}
    />
  );
};

const Aside = (props) => {
  const { isLandscape } = useMobileOrientation()
  const isKeyboardOpen = useDetectKeyboardOpen();

  return (
    <div>
      {((isMobile && isLandscape && !isKeyboardOpen) || !isMobile) ? (
        <div style={{ margin: '1em', overflow: 'auto', height: "700px", width: "100%", borderTopWidth: "3px", borderBottomWidth: "3px" }}>


          <Box sx={{ width: '100%' }}>
            <Typography variant="h6">تاریخچه</Typography>

            <Stepper orientation="vertical" >
              {


                (props.record && props.record.history) ? props.record.history.map((his, i) => (


                  <Step expanded active completed >
                    <StepLabel>
                      {/* <Typography variant="h8">{his.customerNumber}</Typography> */}

                      <ReferenceField link={null} source={`history[${i}].statusId`} reference="status" >
                        <ColoredChipField multiline source="title" select="id" />
                      </ReferenceField>

                      <p>پردازنده : <ReferenceField link={null} source={`history[${i}].unitProcessorId`} reference="unitProcessor" >
                        <TextField fullWidth source="title" />
                      </ReferenceField></p>
                      {/* <Typography variant="h5">عدم موجودی</Typography> */}
                      <div>

                        {new Date(his.updatedAt).toLocaleString("fa", { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', })}
                      </div>
                      <div>
                        تغییر توسط :
                        {his.lastEditBy}
                      </div>
                      {(his.description) ? (
                        <div>

                          <div>
                            پاسخ  :

                          </div>
                          {/* style={{ display: "-webkit-box","-webkit-box-orient": "vertical","-webkit-line-clamp": 3}} */}
                          <div><p style={{ "white-space": "pre-wrap", "overflow-wrap": "break-word", "inline-size": "180px" }}>{his.description}</p></div>
                          {/* <MarkdownField source={`history[${i}].description`} /> */}
                        </div>

                      ) : null}
                      <Divider></Divider>

                    </StepLabel>
                    <StepContent>
                      <RecordContextProvider value="تغییر داده شده">
                      </RecordContextProvider>
                    </StepContent>
                  </Step>
                )) : null
              }
            </Stepper>
          </Box>
        </div>
      ) : (
        <Box></Box>
      )}
    </div>
  )
}

const EditToolbar = props => (
  <Toolbar {...props} >
    <SaveButton />
  </Toolbar>
);
export const NeedEdit = (props) => {
  const { permissions } = usePermissions();
  const classes = useStyles();
  const userId = localStorage.getItem("userId")
  const { data: currentUserData, isLoading: userLoading } = useGetOne('adminUsers',  userId );

  const handleOpenReminderNewTab = () => {
    window.open('/#/reminder/create', '_blank')
  }
  return (
    // <EditView {...props} perPage={20} aside={<Aside />}>

    <Edit redirect={false}  {...props} aside={<Aside />}>
      <SimpleForm redirect={false} submitOnEnter={false} variant="outlined" toolbar={<EditToolbar />}>
        <Button label=" " onClick={handleOpenReminderNewTab} >ایجاد یادآوری</Button>
        <TextInput source="title" validate={required()} />
        <ReferenceInput label="نوع درخواست" validate={required()} source="needCategoryId" reference="needCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>

        <ReferenceField link={null} label="وضعیت کنونی" source="statusId" reference="status" >
          <TextField source="title" />
        </ReferenceField>
        <ReferenceInput label="وضعیت " source="statusId" reference="status" >
          <SelectInput optionText="title" allowEmpty />
        </ReferenceInput>
        <CreateRelatedNeedButton />

        {/* <ReferenceArrayInput variant="outlined" source="subNeeds" label="زیر درخواست ها" reference="need">
          <AutocompleteArrayInput disabled source="title" optionText="title" />
        </ReferenceArrayInput > */}
<FormDataConsumer>
  {({ formData }) => {
    console.log("hasAccesshasAccess",formData?.needParentId);
    return formData?.needParentId ? (
      <ParentNeedDisplay
        needParentId={formData.needParentId}
        permissions={permissions}
        currentUserData={currentUserData}
      />
    ) : null
  }}
</FormDataConsumer>

<ArrayInput source="subNeeds" label="">
  <SimpleFormIterator
    className="grid grid-flow-row-dense mx:grid-cols-1 md:grid-cols-3 grid-rows-3 border-spacing-6 border-cyan-400"
    TransitionProps={{ enter: false, exit: false }}
    variant="outlined"
    disableRemove
    disableAdd
    disableReordering
  >
    <FormDataConsumer>
      {({ scopedFormData ,...rest  } ) => {

        const need = scopedFormData?.nId;
        // const unitProcessorId = scopedFormData?.unitProcessorId;
        const roles = typeof permissions === 'string' ? permissions.split(',') : [];
        const hasAccessByRole = roles.some((role) =>
          [
            ROLES.SUPER_ADMIN,
            ROLES.USERS_ADMIN,
          ].includes(role)
        );

        const hasAccessByUnit = currentUserData &&
        (currentUserData.unitId === need?.unitId || currentUserData.unitProcessorId === need?.unitProcessorId);
  
      const hasAccessToNeed = hasAccessByRole || hasAccessByUnit;
  
        return (
          <>
             <div>
          عنوان :
          {hasAccessToNeed && need?._id ? (
            <a
              href={`/#/need/${need._id}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1976d2', textDecoration: 'underline' }}
            >
              {need.title || 'بدون عنوان'}
            </a>
          ) : (
            <span>{need?.title || 'نامشخص'}</span>
          )}
        </div>
            <div>
                    وضعیت :
                    <ReferenceField {...rest} link={null} label="وضعیت " source="nId.statusId" reference="status" >
                      <TextField source="title" />
                    </ReferenceField>

                  </div>
          </>
        );
      }}
    </FormDataConsumer>
  </SimpleFormIterator>
</ArrayInput>
        <Box sx={{ p: 2, border: '1px dashed grey' }}>
          <div>از طرف</div>
          <ReferenceField link={null} label="از واحد " source="ownerAdmin.unitId" reference="unit" >
            <TextField source="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
          </ReferenceField>
          <TextField source="ownerAdmin.name" label="از طرف" />

        </Box>
        <ReferenceArrayInput variant="outlined" source="usersInvolved" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >

        <Divider></Divider>

        {/* <ReferenceField link={null} label="واحد گیرنده " source="unitId" reference="unit" >
          <TextField source="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        </ReferenceField> */}
        <ReferenceInput label=" واحد گیرنده " source="unitId" validate={required()} reference="unit" >
          <SelectInput optionText="title" />
        </ReferenceInput>
        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ReferenceInput filter={{ unitId: (formData.unitId === undefined) ? "alaki" : formData.unitId }} label=" پردازنده " source="unitProcessorId" validate={required()} reference="unitProcessor" >
              <SelectInput optionText="title"   {...rest} />
            </ReferenceInput>
          )}
        </FormDataConsumer>
        <Divider></Divider>
        {(permissions?.includes(ROLES.SUPER_ADMIN) ||
          permissions?.includes(ROLES.USERS_ADMIN) ||
          permissions?.includes(ROLES.ANBAAR_ADMIN) ||
          permissions?.includes(ROLES.SALE_ADMIN) ||
          permissions?.includes(ROLES.SALE_CRM_ADMIN) ||
          permissions?.includes(ROLES.USER_CRM_SIMPLE) ||
          permissions?.includes(ROLES.UNIT_CRM_USER))

          && <ReferenceField link="show" label=" مخاطب" source="contactId" reference="contact" allowEmpty>
            {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
            <TextField source="name" />
          </ReferenceField>}

        {/* <TextInput source="title" label="مخاطب" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} /> */}
        {(permissions?.includes(ROLES.SUPER_ADMIN) ||
          permissions?.includes(ROLES.USERS_ADMIN) ||
          permissions?.includes(ROLES.ANBAAR_ADMIN) ||
          permissions?.includes(ROLES.SALE_ADMIN) ||
          permissions?.includes(ROLES.SALE_CRM_ADMIN) ||
          permissions?.includes(ROLES.USER_CRM_SIMPLE) ||
          permissions?.includes(ROLES.UNIT_CRM_USER))

          && <ReferenceField link="show" label=" مشتری" source="customerId" reference="customer" allowEmpty>
            {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
            <TextField source="name" />
          </ReferenceField>}

        {/* {permissions?.includes(ROLES.SUPER_ADMIN) && <TextField source="customerName" label="مخاطب" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />}

        {permissions?.includes(ROLES.SUPER_ADMIN) && <TextField source="customerNumber" label="شماره تماس مخاطب" />}
        <Divider></Divider> */}

        {/* <TextField source="descript" /> */}
        <MarkdownField source="descript" sx={{ width: "50%" }} options={options} />

        <Box sx={{ p: 1, border: '1px dashed green' }}>
          <div>کد پیگیری</div>
          <TextField source="refNum" locales="en" textAlign="left" />
        </Box>
        <TextInput source="description_comment" label=" پاسخ" multiline rows={5} width="50%" />
        <TextField source="deliveryLocation" label=" محل تحویل" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        <IdateTimeInput disabled source='dueDate' label="تاریخ تحویل" />

        <ArrayInput source="products" style={{ display: "inline-grid" }}>
          <SimpleFormIterator
            className="grid grid-flow-row-dense mx:grid-cols-1 md:grid-cols-1 grid-rows-1  border-spacing-6 border-cyan-400"
            classes={classes}

          >

            <ReferenceInput label="اقلام" source="objectId" reference="product" filter={{ invisiable: false }} sort={{ field: 'order', order: 'ASC' }}>
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <SelectInput optionText="title" style={styleProduct} />
            </ReferenceInput>
            <TextInput label=" تعداد" source="number" style={styleProductNumber} />
            <TextInput label=" ارسالی" source="sent" style={styleProductNumber}
              disabled={
                ![ROLES.SUPER_ADMIN, ROLES.ANBAAR_ADMIN, ROLES.USERS_ADMIN, ROLES.UNIT_ADMIN].some(
                  (role) => permissions?.includes(role)
                )
              }
            />
            <FormDataConsumer>
              {({ formData, getSource, scopedFormData, ...rest }) => (
                <ProductPackageInput
                  formData={formData}
                  getSource={getSource}
                  scopedFormData={scopedFormData}
                  {...rest}
                  productId={scopedFormData?.objectId} />
              )}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>

        <FileInput source="attachfile" label="سند مربوطه" >
          <ImageField source="src" title="title" />
        </FileInput>
        {/* <TextField source="attachment" /> */}

        <ImageField label="فایل های ضمیمه" source="attachments" src="url" title="دریافت" target="_blank" />



        <br />
      </SimpleForm>
    </Edit>
  )
};

// const UrlFieldClick = ({ record, source }) => <div><a target='_blank' rel="noopener noreferrer" href={record[source]}>{record[source] ? '\n دریافت  سند ' : ''}</a><br/><ChipField source={source} /></div>;

// const UrlFieldClick = ({ record, source }) => <div><ChipField displayName={record[source] ? '\n دریافت  سند \n ' : ''} /><Launch /></div>;

const ProductsShowLayout = (props) => {
  const tableRef = React.useRef(null);

  const dataProvider = useDataProvider();
  const classes = useDatagridStyles(props);

  const record = useRecordContext();
  const [productDetails, setProductDetails] = React.useState([]);
  let heading = ["کالا", "تعداد", "نوع بسته بنندی"];
  React.useEffect(() => {
    const fetchProductDetails = async () => {
      if (record && record.products && record.products.length > 0) {
        const productPromises = record.products.map(product => {
          return dataProvider.getOne('product', { id: product.objectId })
            .then(response => {
              const productDetail = response.data;
              const foundPackage = productDetail.productPackages.find(pkg => pkg._id === product.productPackageId);
              product.productPackageTitle = foundPackage ? foundPackage.title : null;

              return {
                ...product,
                productPackageTitle: foundPackage ? foundPackage.title : null,
                productTitle: productDetail.title
              };
            })
            .catch(error => {
              console.error(`Error fetching product ${product.objectId}:`, error);
              return null;
            });
        });

        try {
          const products = await Promise.all(productPromises);
          setProductDetails(products.filter(Boolean));
        } catch (error) {
          console.error('Error fetching product details:', error);
          setProductDetails([]);
        }
      }
    };

    fetchProductDetails();
  }, [record, dataProvider]);
  const renderTableData = () => {
    return productDetails.map((val) => (
      <tr>
        <td>{val.productTitle}</td>
        <td>{val.number}</td>
        <td>{val.productPackageTitle}</td>
      </tr>))
  }

  return (
    <div>
      <br />
      <br />
      <ReactHTMLTableToExcel
        id="table-xls-button"
        table="table-to-xls"
        filename="Reqeust-export"
        sheet="export"
        buttonText="دریافت فایل خروجی"
      />
      <br />

      <Table
        ref={tableRef}
        id="table-to-xls"
        className={classnames(classes.table)}

        style={{ width: '100%', 'border': 'inset', margin: '10px' }}>
        <thead style={{ 'background-color': 'aqua' }}>
          <tr>
            {heading.map((head, headID) => (
              <th key={headID}>{head}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {renderTableData()}
        </tbody>
      </Table>
    </div>

    // <ArrayField source="productDetails">
    //   <Datagrid>
    //     <ReferenceField link={false} source="objectId" reference="product">
    //       <TextField source="title" />
    //     </ReferenceField>
    //     <TextField label="درخواست" source="number" />
    //     <TextField source="productPackageTitle" label="نوع بسته" />

    //   </Datagrid>
    // </ArrayField>
  )
}

export const NeedShow = (props) => {
  return (
    <Show {...props} aside={<Aside />} actions={null} >
      <SimpleShowLayout>
        <ReferenceField link={null} label="نوع درخواست" source="needCategoryId" reference="needCategory" >
          <TextField source="title" />
        </ReferenceField>
        <ReferenceField link={null} label="وضعیت " source="statusId" reference="status" >
          <TextField source="title" />
        </ReferenceField>

        <TextField source="title" />
        <TextField source="customerName" />
        <TextField source="customerNumber" label="شماره تماس مخاطب" />
        {/* <TextField source="descript" /> */}
        <MarkdownField sx={{ width: "50%" }} source="descript" options={options} />

        <TextField source="refNum" locales="en" textAlign="left" />
        <ReferenceField link={null} label="واحد گیرنده " source="unitId" reference="unit" >
          <TextField source="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        </ReferenceField>

        <ReferenceField link={null} label=" پردازنده " source="unitProcessorId" reference="unitProcessor" >
          <TextField source="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        </ReferenceField>
        <ProductsShowLayout />


        <DateField locales={"fa-IR"} source="createdAt" />
        <DateField locales={"fa-IR"} source="updatedAt" />
        <FileField source="attachment" />
        {/* <ArrayField source="attachments">
        <TextField source="url" />
      </ArrayField> */}
        <FileField label="فایل های ضمیمه" source="attachments" src="url" title="دریافت" target="_blank" />

      </SimpleShowLayout>
    </Show>
  )
};

const options = {
  previewStyle: "tab",
  height: "300px",
  width: "50%",
  initialEditType: "wysiwyg",
  useCommandShortcut: true,
};
export const useStyles = makeStyles(() => ({
  root: {
    float: 'right',

    // position:'absolute'

  },
  form: {
    width: '80%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    float: 'right',

  },
  line: {
    marginRight: '1%',
    height: '50px',

    border: 0,
  },
}));
export const NeedCreate = (props) => {
  const classes = useStyles();

  const { permissions } = usePermissions();

  return (
    <Create redirect="edit" {...props}>
      <SimpleForm variant="outlined" redirect={false} toolbar={<CreateFormActions />}>
        <TextInput source="title" validate={required()} />
        <ReferenceInput label="نوع درخواست" validate={required()} source="needCategoryId" reference="needCategory">
          <SelectInput optionText="title" />
        </ReferenceInput>
        {/* <ReferenceInput label="وضعیت " source="statusId" reference="status"  filter={{ isDefault: true }}>
      <SelectInput optionText="title"  />
    </ReferenceInput> */}
        <ReferenceInput label="واحد گیرنده " source="unitId" validate={required()} reference="unit" >
          <SelectInput optionText="title" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        </ReferenceInput>

        <FormDataConsumer>
          {({ formData, ...rest }) => (
            <ReferenceInput filter={{ unitId: (formData.unitId === undefined) ? "alaki" : formData.unitId }} label=" پردازنده " source="unitProcessorId" validate={required()} reference="unitProcessor" >
              <SelectInput optionText="title"   {...rest} />
            </ReferenceInput>
          )}
        </FormDataConsumer>
        <ReferenceArrayInput variant="outlined" source="usersInvolved" label="همکاران" reference="adminUsers">
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteArrayInput source="name" optionText="name" />
        </ReferenceArrayInput >
        {/* <TextInput source="title" label="مخاطب" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} /> */}
        {(permissions?.includes(ROLES.SUPER_ADMIN) ||
          permissions?.includes(ROLES.USERS_ADMIN) ||
          permissions?.includes(ROLES.ANBAAR_ADMIN) ||
          permissions?.includes(ROLES.SALE_ADMIN) ||
          permissions?.includes(ROLES.SALE_CRM_ADMIN) ||
          permissions?.includes(ROLES.USER_CRM_SIMPLE) ||
          permissions?.includes(ROLES.UNIT_CRM_USER))

          &&
          <ReferenceInput variant="outlined" label=" مشتری" source="customerId" reference="customer" allowEmpty>
            {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
            <AutocompleteInput optionText="name" create={<CreateCustomerOrContactDialog ref="customer" title="مشتری" />} />

          </ReferenceInput>}

        {(permissions?.includes(ROLES.SUPER_ADMIN) ||
          permissions?.includes(ROLES.USERS_ADMIN) ||
          permissions?.includes(ROLES.ANBAAR_ADMIN) ||
          permissions?.includes(ROLES.SALE_ADMIN) ||
          permissions?.includes(ROLES.SALE_CRM_ADMIN) ||
          permissions?.includes(ROLES.USER_CRM_SIMPLE) ||
          permissions?.includes(ROLES.UNIT_CRM_USER))

          && <ReferenceInput label=" مخاطب" source="contactId" reference="contact" display="none" allowEmpty>
            {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
            <AutocompleteInput optionText="name" create={<CreateContactDialog title="مخاطب" />} />

          </ReferenceInput>}
        <ReferenceInput label=" درخواست اصلی" source="needParentId" reference="need" display="none" allowEmpty>
          {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
          <AutocompleteInput optionText="title" create={<CreateContactDialog title="درخواست اصلی" />} disabled />

        </ReferenceInput>
        {/* <TextInput source="customerName" variant='outlined' autoComplete="off" label=" مخاطب" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />

        <TextInput source="customerNumber" variant='outlined' autoComplete="off" label="شماره تماس مخاطب" /> */}

        {/* <FormDataConsumer>
        {({ formData, ...rest }) =>
          // (formData.customerId === undefined) && 
          <div >
                 </div>
        }
      </FormDataConsumer> */}
        {/* <TextInput source="descript" multiline rows={5} /> */}
        <MarkdownInput sx={{ width: "50%" }} source="descript" options={options} />

        {/* <TextInput source="description_comment" label=" پاسخ" multiline rows={5} width="50%" /> */}
        <TextInput source="deliveryLocation" autoComplete="off" label=" محل تحویل" style={{ display: 'inline-grid', float: 'right', marginLeft: '10px' }} />
        <IdateTimeInput style={styleProduct} source='dueDate' label="تاریخ تحویل" />
        <ArrayInput source="products" style={{ display: "inline-grid" }}>
          <SimpleFormIterator
            className="grid grid-flow-row-dense mx:grid-cols-1 md:grid-cols-1 grid-rows-1  border-spacing-6 border-cyan-400"
            classes={classes}
          >

            <ReferenceInput label="اقلام" source="objectId" reference="product" filter={{ invisiable: false }} sort={{ field: 'order', order: 'ASC' }}>
              {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
              <SelectInput optionText="title" style={styleProduct} />
            </ReferenceInput>
            <TextInput label=" تعداد" source="number" style={styleProductNumber} />
            <FormDataConsumer>
              {({ formData, getSource, scopedFormData, ...rest }) => (
                <ProductPackageInput

                  formData={formData}
                  getSource={getSource}
                  scopedFormData={scopedFormData}
                  {...rest}
                  productId={scopedFormData?.objectId} />
              )}
            </FormDataConsumer>
          </SimpleFormIterator>
        </ArrayInput>
        <FileInput source="attachfile" label="سند مربوطه" >
          <ImageField source="src" title="title" />
        </FileInput>


        {/* <ReferenceInput label="اقلام" source="objectId" reference="product">
      <SelectInput optionText="title" />
    </ReferenceInput> */}

      </SimpleForm>
    </Create >
  )
};
const CreateRelatedNeedButton = () => {
  const record = useRecordContext();
  return (
    <Button
      startIcon={<Add />}
      color="primary" variant="outlined"
      style={{ margin: "20px" }}
      component={Link}
      to={{
        pathname: '/need/create',
        state: { record: { needParentId: record.id } },
      }}
    >
      ایجاد زیر درخواست
    </Button>
  )
};
export const ProductPackageInput = ({ productId, formData, getSource, scopedFormData, props }) => {
  const dataProvider = useDataProvider();

  const [productPackages, setProductPackages] = React.useState([]);
  const [defaultPackage, setDefaultPackage] = React.useState(null);

  React.useEffect(() => {
    if (productId) {
      dataProvider.getOne('product', { id: productId })
        .then(({ data }) => {
          setProductPackages(data.productPackages || []);
          if (data.productPackages && data.productPackages.length > 0) {
            setDefaultPackage(data.productPackages[0]._id);
          }
        })
        .catch(error => {
          console.error(error);
          setProductPackages([]);
        });
    }
  }, [productId, scopedFormData?.objectId, dataProvider]);

  return (
    <SelectInput
      label="نوع بسته"
      variant="outlined"
      source={getSource('productPackageId')}
      choices={productPackages.map(pkg => ({
        id: pkg?._id,
        name: pkg?.title
      }))}
      initialValue={defaultPackage}

    />
  );
};

// const ProductPackagesField = ({ record }) => (
//   <ArrayField source="productPackages"  record={record}>
//     <Datagrid>
//       <TextField  source="title" label="Package Title" />
//       {/* Add more fields as needed */}
//     </Datagrid>
//   </ArrayField>
// );

const ParentNeedDisplay = ({ needParentId, permissions, currentUserData }) => {
  const roles = typeof permissions === 'string' ? permissions.split(',') : [];

  const hasAccessByRole = roles.some((role) =>
    [ROLES.SUPER_ADMIN, ROLES.USERS_ADMIN].includes(role)
  );

  const { data: parentNeed, isLoading } = useGetOne('need', needParentId );
  console.log("hasAccesshasAccess" ,parentNeed)

  if (!needParentId || isLoading || !parentNeed) return null;

  const hasAccessByUnit =
    currentUserData &&
    (currentUserData.unitId === parentNeed.unitId ||
      currentUserData.unitProcessorId === parentNeed.unitProcessorId);

  const hasAccess = hasAccessByRole || hasAccessByUnit;
      console.log("hasAccesshasAccess" ,hasAccessByRole,hasAccessByUnit,currentUserData)
  return (
    <div>
درخواست اصلی :
      {hasAccess ? (
        <a
          href={`/#/need/${parentNeed._id}`}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#1976d2', textDecoration: 'underline' }}
        >
          {parentNeed.title || 'بدون عنوان'}
        </a>
      ) : (
        <span>{parentNeed.title || 'نامشخص'}</span>
      )}
    </div>
  );
};

export default ParentNeedDisplay;
